import axios, { type AxiosInstance } from 'axios'

import { getEdunodeServerBaseUrl, getServerApiKey } from '@/services/edunode-api-helpers'

let client: AxiosInstance | null = null

export function getCommunityApiClient(): AxiosInstance {
  if (!client) {
    const isServer = typeof window === 'undefined'
    const apiKey = isServer ? getServerApiKey() : ''
    client = axios.create({
      baseURL: isServer ? getEdunodeServerBaseUrl() : '/api/edunode',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(apiKey ? { 'x-api-key': apiKey } : {}),
      },
    })
  }
  return client
}
